import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "local-video-control-wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconVideo = _resolveComponent("IconVideo")
  const _component_IconVideoOffOutline = _resolveComponent("IconVideoOffOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconChevronUp = _resolveComponent("IconChevronUp")
  const _component_NcActionCaption = _resolveComponent("NcActionCaption")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcActions = _resolveComponent("NcActions")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NcButton, {
      title: $options.videoButtonTitle,
      variant: $props.variant,
      "aria-label": $options.videoButtonAriaLabel,
      class: _normalizeClass({
				'no-video-available': !$options.isVideoAvailable,
				'video-control-button': $props.showDevices,
			}),
      disabled: !$options.isVideoAllowed,
      onClick: _withModifiers($options.toggleVideo, ["stop"])
    }, {
      icon: _withCtx(() => [
        ($options.showVideoOn)
          ? (_openBlock(), _createBlock(_component_IconVideo, {
              key: 0,
              size: 20
            }))
          : (_openBlock(), _createBlock(_component_IconVideoOffOutline, {
              key: 1,
              size: 20
            }))
      ]),
      _: 1
    }, 8, ["title", "variant", "aria-label", "class", "disabled", "onClick"]),
    ($props.showDevices)
      ? (_openBlock(), _createBlock(_component_NcActions, {
          key: 0,
          disabled: !$options.isVideoAvailable || !$options.isVideoAllowed,
          class: "video-selector-button",
          onOpen: $setup.updateDevices
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconChevronUp, { size: 16 })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_NcActionCaption, {
              name: $options.t('spreed', 'Select a video device')
            }, null, 8, ["name"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.videoDevices, (device) => {
              return (_openBlock(), _createBlock(_component_NcActionButton, {
                key: device.deviceId ?? 'none',
                class: "video-selector__action",
                type: "radio",
                "model-value": $setup.videoInputId,
                value: device.deviceId,
                title: device.label,
                onClick: $event => ($options.handleVideoInputIdChange(device.deviceId))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(device.label), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "value", "title", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled", "onOpen"]))
      : _createCommentVNode("", true)
  ]))
}